<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M9.83105 3.25L11.0902 5.69402C11.258 6.0197 11.6365 6.1765 11.9855 6.06485L14.6041 5.22703L13.7662 7.84557C13.6546 8.19451 13.8114 8.57305 14.137 8.74083L16.5811 10L14.2377 11.2073C13.8702 11.3967 13.7252 11.8477 13.9135 12.2157L15.8705 16.0395L12.0468 14.0825C11.6788 13.8942 11.2277 14.0391 11.0383 14.4066L9.83105 16.75L8.57188 14.306C8.4041 13.9803 8.02556 13.8235 7.67663 13.9352L5.05808 14.773L5.89591 12.1544C6.00755 11.8055 5.85076 11.4269 5.52507 11.2592L3.08105 10L5.42441 8.79272C5.79194 8.60335 5.93692 8.15232 5.74856 7.78429L3.79158 3.96053L7.61534 5.91751C7.98337 6.10587 8.4344 5.96088 8.62378 5.59336L9.83105 3.25Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'BreakoutIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>